/**
 * Created by fengzhiwei on 2019/3/11.
 */
import {su} from '@/utils/server-utils.js'

export function redirectWX(path, params)
{
    var APPID = "wx5099cdc88d440ba7";

    //这里不再是 webroot 而是 SiteRoot，靠，否则导致微信跳转错误！！
    var url = su.SiteRoot() + path;   //警告，path 要自带斜杠，比如  "/login"

    let pstr = ""
    for(let v in params)
    {
        if(pstr) {pstr+="&"}
        pstr+= v + "=" + params[v]
    }
    if(pstr) {
        url += "?"+pstr;
    }
    var REDIRECT_URI = encodeURIComponent(url);
    window.location.href = "https://open.weixin.qq.com/connect/oauth2/authorize?appid=" + APPID + "&redirect_uri=" + REDIRECT_URI + "&response_type=code&scope=snsapi_base&state=STATE#wechat_redirect"
}

export function isWeiXinBrowser(){
    var ua = navigator.userAgent.toLowerCase();
    var isWeixin = ua.indexOf('micromessenger') != -1;
    if(isWeixin) {
        return true;
    } else {
        return false;
    }
}

export function getUrlQueryString(name) {
    var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
    var r = window.location.search.substr(1).match(reg);
    if (r != null) return unescape(r[2]);
    return null;
}

export function isIOS() {
    var u = navigator.userAgent
    var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1; //g
    var isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
    if(isAndroid) {
		//这个是安卓操作系统
		return false
    }
    //这个是ios操作系统
    if(isIOS){
		return true
    }
}